// src/pages/OfficeAdministrator.js
import React from 'react';
import '../HumanResources.css';

function OfficeAdministrator() {
  return (
    <div className="hr-page">
      <h1>OFFICE ADMINISTRATOR</h1>

      <h2>Overview</h2>
      <p>
        The Office Administrator supports the smooth daily operations of Nesim. Their responsibilities include:
      </p>
      <ul>
        <li>Maintaining correspondence with stakeholders such as suppliers and forwarding agents, facilitating communication and coordination.</li>
        <li>Supervising the loading and delivery of products, ensuring efficient logistics.</li>
        <li>Creating and updating databases of suppliers, customers, and staff, maintaining organized records.</li>
        <li>Tracking and replacing office supplies, ensuring a functional work environment.</li>
        <li>Submitting reports and preparing presentations, supporting management with information and communication.</li>
        <li>Supervising casual employees, ensuring adequate support for operational tasks.</li>
        <li>Managing basic administrative tasks and assisting the chief accountant.</li>
        <li>Collaborating with other departments like finance and sales to ensure alignment and smooth operations.</li>
      </ul>

      <h2>Qualifications</h2>
      <ul>
        <li>Diploma or Certificate in Office Administration, Business Administration, or a related field. A Bachelor's degree is an advantage.</li>
        <li>3+ years of proven experience as an Office Administrator, Administrative Assistant, or in a similar role.</li>
        <li>Excellent organizational and time management skills, with the ability to prioritize tasks and meet deadlines.</li>
        <li>Strong attention to detail and accuracy.</li>
        <li>Excellent written and verbal communication skills.</li>
        <li>Proficient in Microsoft Office Suite (Word, Excel, PowerPoint, Outlook).</li>
        <li>Experience with office equipment (e.g., printers, copiers, scanners).</li>
        <li>Ability to handle confidential information with discretion.</li>
        <li>Strong problem-solving skills and the ability to take initiative.</li>
        <li>Professional and positive demeanor.</li>
      </ul>

      <h2>Proposed Job Levels for Head of Office Administrator Role</h2>
      <p>
        This structure provides a potential progression for the Office Administrator role at Nesim, moving from basic support to more comprehensive management and potentially supervisory responsibilities.
      </p>

      <h3>Level 1: Administrative Assistant/Office Clerk</h3>
      <ul>
        <li>
          <strong>Focus:</strong> Primarily on basic administrative tasks and providing support to the office.
        </li>
        <li>
          <strong>Responsibilities:</strong>
          <ul>
            <li>Assisting with maintaining correspondence with various company stakeholders such as suppliers and forwarding agents.</li>
            <li>Providing support in supervising the loading and delivery of products to the customers.</li>
            <li>Assisting with the creation and updating of databases and records of suppliers, customers, and company staff under supervision.</li>
            <li>Tracking and replacing office supplies and stationery.</li>
            <li>Assisting with basic administrative tasks within the company.</li>
            <li>Potentially providing support to other departments with basic administrative needs.</li>
          </ul>
        </li>
      </ul>

      <h3>Level 2: Office Administrator</h3>
      <ul>
        <li>
          <strong>Focus:</strong> Managing a broader range of administrative responsibilities and ensuring the smooth functioning of the office.
        </li>
        <li>
          <strong>Responsibilities:</strong>
          <ul>
            <li>Maintain correspondence with various company stakeholders (e.g. suppliers, forwarding agents) independently.</li>
            <li>Supervise the loading and delivery of products to the customers by coordinating with casual employees.</li>
            <li>Create and update databases and records of suppliers, customers, and company staff, ensuring data accuracy and generating reports as needed.</li>
            <li>Proactively track and replace office supplies and stationery.</li>
            <li>Submit reports and prepare presentations as needed, demonstrating strong organizational and presentation skills.</li>
            <li>Supervise casual employees, especially during loading and unloading operations.</li>
            <li>Manage basic administrative tasks within the company, including coordination of events and personnel.</li>
            <li>Ensure effective communication with managers and staff, and collaborate with other departments.</li>
          </ul>
        </li>
      </ul>

      <h3>Level 3: Senior Office Administrator/Office Manager</h3>
      <ul>
        <li>
          <strong>Focus:</strong> Taking on more responsibility for office operations, potentially supervising other administrative staff, and contributing to organizational efficiency.
        </li>
        <li>
          <strong>Key Responsibilities:</strong>
          <ul>
            <li>Managing and mentoring junior administrative staff (if applicable).</li>
            <li>Developing and implementing office policies and procedures.</li>
            <li>Managing relationships with office vendors and service providers.</li>
            <li>Assisting with budget preparation and monitoring for office expenses.</li>
            <li>Coordinating office maintenance and repairs.</li>
            <li>Contributing to the planning and execution of company events.</li>
            <li>Handling more complex administrative tasks and projects as needed.</li>
            <li>Potentially managing specific administrative functions such as travel arrangements or record management.</li>
            <li>Driving process improvements within the administrative function.</li>
          </ul>
        </li>
      </ul>
    </div>
  );
}

export default OfficeAdministrator;
